import { useState } from "react";

export default function useFormSearch() {
  const [keyword, setKeyword] = useState<string>("");
  const [page, setPage] = useState<number>(1);

  return { keyword, setKeyword, page, setPage };
}
